// extracted by mini-css-extract-plugin
module.exports = {"main":"CharterListPage_main__1HmFE","title":"CharterListPage_title__1WKbn","navigation":"CharterListPage_navigation__1_PrH","partnership":"CharterListPage_partnership__2Ijaw"};